<template>
  <div >
    <div  v-if="nota_jasa_bkl || nota_jasa_bkl != null" class="md-layout noprint">
      <md-toolbar class="color md-dense">
        <div class="md-toolbar-section-end">
        <h3 class="md-title" style="flex:1;">
        </h3>
        <md-button  class="noprint md-dense md-icon-button color" @click="printPage()" ><md-icon>print</md-icon></md-button>
        <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
          <md-button class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
          <md-menu-content>
            <md-menu-item v-if="role.update" @click="editNotaJasaBkl(nota_jasa_bkl.id)">Edit</md-menu-item>
            <md-menu-item v-if="role.delete" @click="deleteConfirmation(nota_jasa_bkl.id)">Delete</md-menu-item>
            <md-menu-item @click="backtoList">Back to NJ list</md-menu-item>
          </md-menu-content>
        </md-menu> -->
        <md-button class="md-icon-button md-dense color" @click="closeDetail()"><md-icon>close</md-icon></md-button>
        </div>
      </md-toolbar>
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Nota Jasa No</b></md-table-head>
                <md-table-head><b>Tanggal Nota Jasa</b></md-table-head>
                <md-table-head><b>PKB No</b></md-table-head>
                <md-table-head><b>Tanggal PKB</b></md-table-head>
                <md-table-head><b>Mengetahui</b></md-table-head>
                <md-table-head><b>Diperiksa</b></md-table-head>
                <md-table-head><b>Dibuat</b></md-table-head>
              </md-table-row>
              <md-table-row>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_no}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_datetime}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.pkb_no}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.pkb_datetime}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_mengetahui_name.name}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.sa_name.name}}</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_dibuat.name}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100" style="margin-top:10px;">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Client</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Client Name</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_name}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Phone</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_phone}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Address</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_address}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Police No</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.vehicle_plate_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Chassis No</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.vehicle_chasis_no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell style="font-weight:bold; width:50mm;">Vehicle Type</md-table-cell>
                <md-table-cell>{{nota_jasa_bkl.vehicle_model}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-medium-size-200 md-xsmall-size-200 md-size-100" style="margin-top:10px;">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Service</h4>
            </div>
          </md-card-header>
          <md-card-content>
           <md-table>
              <md-table-row>
                <md-table-head ><b>No</b></md-table-head>
                <md-table-head ><b>Service Code</b></md-table-head>
                <md-table-head ><b>Description</b></md-table-head>
                <md-table-head ><b>LTS</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Price</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Discount(%)</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Total</b></md-table-head>
              </md-table-row>
              <md-table-row v-for="(item, index)  in nota_jasa_bkl.nota_jasa_bkl_service" :key="index">
                <md-table-cell >{{ index+1 }}</md-table-cell>
                <md-table-cell >{{ item.service_master_code }}</md-table-cell>
                <md-table-cell >{{item.service_master_name}}</md-table-cell>
                <md-table-cell>{{item.service_master_lts}}</md-table-cell>
                <md-table-cell>
                  <span style="float: left;">Rp</span>
                  <span style="float: right;">{{ formatPrice(item.service_category_standard_cost) }}</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">{{ item.pkb_service_discount }}</md-table-cell>
                <md-table-cell>
                  <span style="float: left;">Rp</span>
                  <span v-if="item.pkb_service_discount" style="float: right;">{{formatPrice((item.service_master_lts * item.service_category_standard_cost) - ((item.service_master_lts * item.service_category_standard_cost) * item.pkb_service_discount / 100)) }}</span>
                  <span v-else style="float: right;">{{formatPrice(item.service_master_lts * item.service_category_standard_cost)  }}</span>
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell colspan="5"></md-table-cell>
                <md-table-cell style="text-align:center;"><b>Total</b></md-table-cell>
                <md-table-cell >
                  <span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total)}}</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div  v-if="nota_jasa_bkl || nota_jasa_bkl != null" class="md-layout ">
      <div class="md-layout-item md-size-100 print">
          <md-content>
            <table class="noprint" style="width: 100%; table-layout: fixed; text-transform: capitalize ;">
             <colgroup>
               <col style="width: 7mm">
               <col style="width: 18mm">
               <col style="width: 20mm">
               <col style="width: 120mm">
               <col style="width: 15mm">
             </colgroup>
            <tr>
              <td ></td>
              <td></td>
              <td ></td>
              <td><md-button style="float: right; " class="noprint" @click="printPage()" ><md-icon>print</md-icon></md-button></td>
              <td >
                <md-menu md-direction="bottom-start">
                  <md-button class="nonprint; md-info" md-menu-trigger>Option</md-button>
                  <md-menu-content>
                    <md-menu-item v-if="role.update" @click="editNotaJasaBkl(nota_jasa_bkl.id)">Edit</md-menu-item>
                    <md-menu-item v-if="role.delete" @click="deleteConfirmation(nota_jasa_bkl.id)">Delete</md-menu-item>
                    <!-- <md-menu-item @click="backtoList">Back to NJB list</md-menu-item> -->
                  </md-menu-content>
                </md-menu>
              </td>
            </tr>
          </table>
            <table class="print" style="width:100%; table-layout: fixed; border: 1px solid black;" >
              <tr>
                <td style="width:50mm; border: 1px solid black;"  rowspan="4"><img src="@/assets/images/logocharged.png" style="width:100%;"></td>
                <td style="padding-left:10mm; font-size: 4mm;  font-weight: 900; text-decoration: underline;">CHARGED INDONESIA</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">JAKARTA</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Jl. Kemang Utara VII No.21B, Bangka, Kec. Mampang Prpt., Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12730</td>
              </tr>
              <tr>
                <td style="padding-left:10mm; font-size: 3.5mm; font-weight: 900;">Phone : 081280004426</td>
              </tr>
            </table>
            
            <table style="width:100%;  margin-top: 2px;" >
              <tr>
                <td style="width:75%"><b>NOTA JASA BENGKEL</b></td>
              </tr>
            </table>
            
            <table style="width:180mm;  margin-top: 3mm;" >
              <tr>
                <td style="width:80mm">
                  <table id="font-size" style="width:100%; table-layout: margin-top: 2px;" >
                    <colgroup>
                      <col style="width:25mm">
                      <col style="width:5mm">
                      <col style="width:50mm">
                    </colgroup>
                    <tr>
                      <td ><b>Nomor</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.nota_jasa_bkl_no}}</td>
                    </tr>
                    <tr>
                      <td ><b>Tanggal</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.nota_jasa_bkl_datetime}}</td>
                    </tr>
                    <tr>
                      <td ><b>No. PKB</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.nota_jasa_bkl_pkb.pkb_no}}</td>
                    </tr>
                    <tr>
                      <td ><b>Tanggal PKB</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.nota_jasa_bkl_pkb.pkb_datetime}}</td>
                    </tr>
                    <tr>
                      <td ><b>No. Polisi</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.vehicle_plate_no}}</td>
                    </tr>
                    <tr>
                      <td ><b>No. Rangka</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.vehicle_chasis_no}}</td>
                    </tr>
                    <tr>
                      <td ><b>Tipe</b></td>
                      <td ><b>:</b></td>
                      <td >{{nota_jasa_bkl.vehicle_model}}</td>
                    </tr>
                  </table>
                </td>
                <td style="width:100mm">
                  <table id="font-size" style="width:100%; table-layout: fixed; border: 1px solid black; margin-top: 2px;" >
                    <tr>
                      <td style="width:17%"><b>KEPADA YTH :</b></td>
                    </tr>
                    <tr>
                      <td>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_name}}</td>
                    </tr>
                    <tr>&zwnj;</tr>
                    <tr>
                      <td>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_address}}</td>
                    </tr>
                    <tr>&zwnj;</tr>
                    <tr>
                      <td>{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.client.client_phone}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            
            <tr>&zwnj;</tr>
            <table style="width:100%;">
              <tr>
                <td style="width:41%"></td>
                <td ><b>SERVICE</b></td>
              </tr>
            </table>
            
            <table class="table-kotak" style="border-collapse: width:100%; collapse; margin-top:10px; margin-bottom:10px;">
              <thead>
                <tr>
                  <th class="title-name" style="width:10mm">No</th>
                  <th class="title-name">Service Code</th>
                  <th class="title-name" style="width:60mm">Description</th>
                  <th class="title-name" style="width:10mm">LTS</th>
                  <th class="title-name">Price</th>
                  <th class="title-name">Disc(%)</th>
                  <th class="title-name">Total</th>        
                </tr>
              </thead>
              <tr v-for="(item, index)  in nota_jasa_bkl.nota_jasa_bkl_service" :key="index">
                <td >{{ index+1 }}</td>
                <td >{{ item.service_master_code }}</td>
                <td >{{ item.service_master_name }}</td>
                <td >{{ item.service_master_lts }}</td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{ formatPrice(item.service_category_standard_cost) }}</span></td>
                <td >{{ item.pkb_service_discount }}</td>
                <td ><span style="float: left;">Rp</span><span v-if="item.pkb_service_discount" style="float: right;">{{formatPrice((item.service_master_lts * item.service_category_standard_cost) - ((item.service_master_lts * item.service_category_standard_cost) * item.pkb_service_discount / 100)) }}</span>
                <span v-else style="float: right;">{{formatPrice(item.service_master_lts * item.service_category_standard_cost)  }}</span>
                </td>
              </tr>
              <tr >
                <td colspan="5"></td>
                <td><b>Total</b></td>
                <td ><span style="float: left;">Rp</span><span style="float: right;">{{formatPrice(total)}}</span></td>
              </tr>
            </table>

            <table id="signature" style="width:100%;  margin-top: 2px;" >
              <colgroup>
                <col style="width:35mm;">
                <col style="width:35mm;">
                <col style="width:35mm;">
              </colgroup>
              <tr>
                <td style="text-align:center"><b>MENGETAHUI,</b></td>
                <td style="text-align:center"><b>DIPERIKSA OLEH,</b></td>
                <td style="text-align:center"><b>DIBUAT OLEH,</b></td>
              </tr>
              <tr>&zwnj;</tr>
              <tr>&zwnj;</tr>
              <tr>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{nota_jasa_bkl.nota_jasa_bkl_mengetahui_name.name}}</span><sub>)</sub></td>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;">{{nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.sa_name.name}}</span><sub>)</sub></td>
                <td style="text-align:center"><sub>(</sub><span style="display:inline-block; border-bottom:1px solid black; padding-left:30px; padding-right:30px;"></span><sub>)</sub></td>
              </tr>
            </table>
          </md-content>
          <!-- <button class="noprint" @click="printInvoice" >Print Invoice</button>
          <button class="noprint" @click="generateReport" >Print Invoice</button> -->
        
      </div>
    </div>
    
    <div v-bind:style="{ display: not_found}">
      <center  v-if="nota_jasa_bkl == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Go to List?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import angkaTerbilang from '@develoka/angka-terbilang-js';

  // import InfoCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/InfoCard.vue";
  // import ClientCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ClientCard.vue";
  // import VehicleCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/VehicleCard.vue";
  // import ServiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/ServiceCard.vue";
  // import PartCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/PartCard.vue";
  import Vue from "vue";
  export default {
     name: "detail-nota-part",

    props: {
      // service_estimate: Object,
      data_id:null,
    },

    components: {
      // ValidationError,
      // FormWizard,
      // TabContent,
      // "info-card": InfoCard,
      // "client-card": ClientCard,
      // "vehicle-card": VehicleCard,
      // "service-card": ServiceCard,
      // "part-card": PartCard,
      
    }, 

    mixins: [formMixin],

    data: () => ({
      not_found: 'none',
      role: '',
      nota_jasa_bkl: null,
      total:0
    }),

    created() {
      this.getNotaJasaBklData();
    },

    methods: {
      //format uang
      formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      //ambil data nota jsa bkl dari api berdasarkan id yang ikut dikirim saat pindah page melalui route
      async getNotaJasaBklData(){
          
        this.role =  await this.$store.getters["role_permission/route_filter"]
        await this.$store.dispatch("workshop_nota_jasa_bkl/get", this.data_id.id)
        this.nota_jasa_bkl = await this.$store.getters["workshop_nota_jasa_bkl/nota_jasa_bkl"]

         //check apakah data dari api ada
        if(!this.nota_jasa_bkl){
          //jika tidak ada munculkan bagian not found yang defaultnya di hide
          this.not_found = "block"
          return
        }

        this.calculateTotal();
        
        
        // this.nota_jasa_bkl.faktur_total_terbilang =  angkaTerbilang(this.faktur.faktur_total_biaya_jasa + this.faktur.faktur_total_biaya_spare_part + this.faktur.faktur_materai + this.faktur.faktur_ppn)
       // console.log(await this.$store.getters["workshop_nota_jasa_bkl/nota_jasa_bkl"])
          this.nota_jasa_bkl.vehicle_chasis_no = null
          this.nota_jasa_bkl.vehicle_plate_no = null
          this.nota_jasa_bkl.vehicle_model = null
          if(this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types){
            this.nota_jasa_bkl.vehicle_chasis_no = this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types.vehicle_chassis_no
            this.nota_jasa_bkl.vehicle_plate_no = this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types.vehicle_plate_no
            this.nota_jasa_bkl.vehicle_model = this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name+', '+ this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model+' '+ this.nota_jasa_bkl.nota_jasa_bkl_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_year_model
          }
         
        
      },

      closeDetail(){
        if(this.data_id.mode && this.data_id.mode == "pkb"){
            this.$parent.$parent.modalCloseshowNotaJasa();
          }
          else{
            this.$parent.$parent.modalCloseDetail();

          }
      },

      //pindah ke page edit.
      editNotaJasaBkl(id) {
        //push ke page edit beserta dengan id nota jsa bkl
        this.$router.push({ name: 'Edit Nota Jasa Bkl', params: { nota_jasa_bkl:id, id } })
      },

      

      //konfirmasi hapus
      deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.deleteNotaJasaBkl(id)
          }
        });
      },

      //hapus data/record
      async deleteNotaJasaBkl(id) {
        try {
          //kirim data yang akan di hapus ke api
          await this.$store.dispatch("workshop_nota_jasa_bkl/destroy", id)
          //panggil alert succes
          await this.$store.dispatch("alerts/success", "Nota Jasa Bkl  data delete successfully.")
          //kembali ke list
          this.$router.replace({ name: 'List Nota Jasa Bkl'})
        } catch (e) {
          //panggil alert error
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.setApiValidation(e.response.data.errors)
        }
      },

      //fungsi untuk menghitung total biaya
      calculateTotal(){
          console.log(this.nota_jasa_bkl.nota_jasa_bkl_service)
        var total = 0;
        this.nota_jasa_bkl.nota_jasa_bkl_service.map(function(value, key) {
            // jika tanpa discount, dilakukan penjumlahan tanpa discount
            if(value.pkb_service_discount == null){
                total = total + (value.service_master_lts * value.service_category_standard_cost)
            } else{
              // penjumlahan dengan discount
              total = total + (value.service_master_lts * value.service_category_standard_cost) - ((value.service_master_lts * value.service_category_standard_cost)* value.pkb_service_discount / 100) 
            }
           
        });
        this.total = total
          
      },
      //kembali ke list
      async backToList(){
          await this.$router.replace({name: 'List Nota Jasa Bkl'})
      },
      //mode preview screen
      printPage(){
         window.print()
      }
      
    }
  };
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
.checkboxes label {
  display: inline-block;
  padding-right: 10px;
  white-space: nowrap;
}
.checkboxes input {
  vertical-align: middle;
}
.checkboxes label span {
  vertical-align: middle;
}
.checkboxes td {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.checkboxes {
  padding: 0px;
  line-height: 0px;
  margin: 0px;
}
.info {
  line-height: 17px;
}
.info td {
margin: 4px;
}
.bold-title{
font-weight:bold;
}

.table-inside-td td {
  vertical-align: top;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}


@media print{
   .print{
       visibility: visible;
   }
   .noprint{
     display: none;
   }

  
}

.color{
  background-color: #1976d2 !important;
}

</style>